export default "__VITE_ASSET__BOCN7axV__"